export default ({ request }) => ({
  userTripRequestListApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/request/list',
      method: 'post',
      data
    })
  },
  userTripRequestDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/request/detail',
      method: 'post',
      data
    })
  },
  userTripRequestDelApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/request/del',
      method: 'post',
      data
    })
  },
  userTripRequestSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/request/save',
      method: 'post',
      data
    })
  },
  userTripRequestScheduleListApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/request/schedule/list',
      method: 'post',
      data
    })
  },
  userTripRequestScheduleDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/request/schedule/detail',
      method: 'post',
      data
    })
  },
  userTripRequestScheduleDelApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/request/schedule/del',
      method: 'post',
      data
    })
  },
  userTripRequestScheduleSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/user/trip/request/schedule/save',
      method: 'post',
      data
    })
  },
  userTripRequestOaApply(data = {}) {
    return request({
      url: '/oa/usertrip/request/apply',
      method: 'post',
      data,
    })
  },
})
